import React from 'react';
import { Routes } from '@App/paths';
import { Button, Tile } from '@Components/common';
import { useTranslation } from 'react-i18next';
import styles from './OrganizationVerify.module.scss';

interface OrganizationVerifyProps {
  informationCardsDetails: {
    title: string;
    description: string;
    icon: string;
    iconAlt: string;
  }[];
}
export const OrganizationVerify = ({ informationCardsDetails }: OrganizationVerifyProps) => {
  const { t } = useTranslation('account');

  return (
    <div className={styles.container}>
      <img
        src="/assets/OrganizationVerify/OrganizationVerifyGraphic.svg"
        alt="Project published graphic"
        className={styles.image}
      />
      <h1 className={styles.title}>{t('verify.title')}</h1>
      <p className={styles.subtitle}>{t('verify.subtitle')}</p>
      <Tile className={styles.tile}>
        <>
          {informationCardsDetails.map(({ title, description, icon, iconAlt }) => (
            <div className={styles.informationCard}>
              <img src={icon} alt={iconAlt} className={styles.informationCardIcon} />
              <div className={styles.informationCardContent}>
                <h2 className={styles.informationCardTitle}>{title}</h2>
                <p className={styles.informationCardDescription}>{description}</p>
              </div>
            </div>
          ))}
        </>
      </Tile>
      <div className={styles.buttonContainer}>
        <Button buttonType="secondary" to={Routes.DASHBOARD_GROUP}>
          {t('verify.skip_button')}
        </Button>
        <Button buttonType="primary" to={Routes.ACCOUNT('organization')}>
          {t('verify.verify_button')}
        </Button>
      </div>
    </div>
  );
};
